import { Select } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage, useIntl } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { useAppSelector } from '@/store/hooks.ts';
import type { HedgeType } from '@/store/option/state.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';

const DefaultHedgeType = () => {
  const { formatMessage } = useIntl();
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = ({ value }: { defaultHedgeType: string; value: Exclude<HedgeType, 'Ndf'> }): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, option tab, default hedge type', value);
    updateUserPreferences({ ...userPreferences, defaultHedgeType: value });
  };

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="default-hedge-type">
        <FormattedMessage id="userPreferences.label.defaultHedgeType" />
      </label>
      <Select
        id="default-hedge-type"
        itemValue={(item) => item.value}
        selectedItemValue={userPreferences.defaultHedgeType}
        itemsAsObjects={[
          { defaultHedgeType: formatMessage({ id: 'userPreferences.label.defaultHedgeType.Live' }), value: 'Live' },
          { defaultHedgeType: formatMessage({ id: 'userPreferences.label.defaultHedgeType.spot' }), value: 'Spot' },
          {
            defaultHedgeType: formatMessage({ id: 'userPreferences.label.defaultHedgeType.forward' }),
            value: 'Forward',
          },
        ]}
        itemToString={({ defaultHedgeType }) => defaultHedgeType}
        onChange={handleChange}
        className="w-auto"
      />
    </div>
  );
};

export default DefaultHedgeType;
